module.exports = __webpack_public_path__ + "img/audio-muted.edb5f65f.svg";